var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenexIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 761.451,
    height: 981.696,
    viewBox: "0 0 761.451 981.696",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_485",
    "data-name": "Group 485",
    transform: "translate(515.524 -5043.995)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M378.931.046C565.705,0,726.449,132.4,755.425,314.633c25.539,160.629-30.217,291.5-165.029,383.056-82.6,56.1-149.724,186.832-196.951,274.5-2.707,5.024-5.908,9.368-12.233,9.5-6.812.149-10.087-4.551-12.954-9.829-47.018-86.449-113.735-217.438-195.066-271.922C86.233,641.69,29.573,561.851,8.662,459.08c-24.713-121.454,3.56-230.905,83.489-325.661C152.837,61.474,231.2,19.331,324.033,4.3a312.67,312.67,0,0,1,54.9-4.252",
    transform: "translate(-515.524 5043.995)",
    fill: "#f7696e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    transform: "translate(-424.798 5128.783)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 290,
    r: 290,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 290,
    r: 289.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_484",
    "data-name": "Group 484",
    transform: "translate(-628.268 245)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M317.409,356.138c2.255.007,4.51.042,6.765.016,4.428-.053,7.281,2.215,7.456,6.507.218,5.317.234,10.656-.008,15.971-.212,4.639-2.656,6.345-8.247,6.345q-131.59,0-263.18,0-16.173,0-32.348,0c-5.442-.009-7.728-2.314-7.652-7.79.066-4.785.2-9.57.379-14.352.157-4.232,2.156-6.235,6.467-6.479,2.52-.143,5.051-.125,7.575-.18,13.18.031,26.366-.081,39.542.183,3.877.078,5.126-.712,5.111-4.932-.175-48.609-.114-97.219-.11-145.828,0-9.167,4.221-13.379,13.4-13.379,55.531,0,111.061.076,166.591-.089,7.858-.023,13.391,3.5,13.439,13.343.062,12.649.022,25.3.022,37.948q0,54.735-.034,109.471c0,2.131.172,3.488,2.92,3.428,8.65-.187,17.306-.142,25.958-.186l15.962.007M160.556,273.3c-8.525-.033-17.052-.21-25.573-.057-8.494.153-12.751,4.58-12.761,12.939-.027,21.982.06,43.965-.085,65.947-.022,3.331.91,4.233,4.229,4.221q49.556-.18,99.112,0c3.324.012,4.251-.9,4.229-4.227-.143-21.848-.061-43.7-.082-65.548-.008-8.733-4.141-13.17-12.783-13.33-8.522-.159-17.049.023-25.573.056q-15.356-.733-30.713,0",
    transform: "translate(329.988 4936.823)",
    fill: "#676666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M305.019,333.147c-8.653.045-17.308,0-25.959.187-2.748.059-2.922-1.3-2.919-3.428q.06-54.736.034-109.472c0-12.649.04-25.3-.021-37.947-.048-9.849-5.581-13.366-13.439-13.343-55.53.164-111.06.086-166.591.088-9.175,0-13.4,4.212-13.4,13.38,0,48.609-.065,97.219.11,145.828.015,4.22-1.234,5.01-5.11,4.932-13.177-.264-26.362-.151-39.542-.182Q38.176,242.1,38.168,151c0-.8.065-1.6.1-2.393,3.822-2.393,7.632-4.808,11.471-7.176,31.763-19.59,63.592-39.075,95.268-58.8,12.212-7.607,24.112-8.562,36.591-.724,17.545,11.019,35.3,21.711,52.912,32.617,14.787,9.155,29.933,17.81,44.151,27.785,17.389,12.2,26.234,29.609,26.294,51,.131,46.613.056,93.226.065,139.839M179.555,96.481a23.032,23.032,0,0,0-23.432,23.474c.017,13.188,10.26,23.361,23.6,23.439,12.576.074,23.074-10.715,23.031-23.668-.044-13.21-10.055-23.24-23.2-23.246M58.084,238.968c0-7.043-.028-14.086.016-21.129.014-2.186-.335-4.327-2.921-4.313-2.285.012-2.813,1.973-2.809,4.049q.038,21.328.006,42.657c0,2.246.611,4.166,3.217,4.052,2.591-.114,2.488-2.292,2.489-4.187q.006-10.564,0-21.129m-.02-44c0-1.456.021-2.912-.006-4.367-.03-1.659-.708-2.823-2.519-2.95-2.009-.139-2.986,1.072-3.075,2.851-.144,2.9-.089,5.821-.046,8.731a2.62,2.62,0,0,0,2.98,2.91,2.52,2.52,0,0,0,2.651-2.809c.03-1.455.006-2.911.014-4.367",
    transform: "translate(326.416 4959.807)",
    fill: "#fec26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    d: "M30.4,125.4c-1.044.562-2.111,1.087-3.129,1.692-9.027,5.367-19.62,3.047-24.738-5.43-5.126-8.492-2.272-18.9,6.728-24.469q23.6-14.586,47.2-29.152,52.313-32.273,104.6-64.586c7.386-4.587,14.264-4.615,21.638-.047q43.6,27.01,87.352,53.764c-1.242,10.047-.463,20.024.94,30,.606,4.31,2.338,8.4,2.355,12.812-1.281-.692-2.6-1.324-3.838-2.087Q222.65,69,175.846,40.012c-2.952-1.837-4.966-1.665-7.817.107Q120.608,69.609,73.04,98.862C58.8,107.667,44.612,116.552,30.4,125.4m88.54-81.15a2.816,2.816,0,0,0-1.223-2.379c-1.4-1.033-2.745-.561-4.061.252q-18.8,11.61-37.594,23.215c-1.616,1-2.771,2.352-1.631,4.256,1.23,2.057,3.063,1.72,4.833.629Q97.9,58.74,116.527,47.241a4.331,4.331,0,0,0,2.413-2.99m15.741-10.139a3.484,3.484,0,0,0-.3-.966c-1.571-2.56-3.618-1.881-5.4-.473-2.023,1.6-6.11,1.93-4.367,6.192a2.445,2.445,0,0,0,1.147,1.034c2.194,1.12,8.937-3.152,8.914-5.788",
    transform: "translate(334 4975)",
    fill: "#c48a58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    d: "M37.939,135c14.212-8.849,28.4-17.733,42.64-26.538q47.495-29.372,94.989-58.744c2.85-1.772,4.865-1.945,7.817-.107q46.745,29.088,93.671,57.883c1.238.763,2.557,1.394,3.838,2.085a9.606,9.606,0,0,1,1.841,3.9A104.924,104.924,0,0,0,289.66,129.5c7.649,14.123,18.3,25.532,31.292,34.85q-.008,81.607-.018,163.213l-15.961-.007c-.009-46.613.066-93.226-.065-139.838-.06-21.391-8.906-38.8-26.294-51-14.217-9.975-29.363-18.63-44.151-27.785-17.616-10.906-35.367-21.6-52.912-32.617-12.479-7.837-24.379-6.883-36.591.724-31.676,19.729-63.5,39.215-95.268,58.8-3.84,2.368-7.65,4.782-11.472,7.176q-.139-4.008-.282-8.017",
    transform: "translate(326.461 4965.4)",
    fill: "#fedaa7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    d: "M216.549,293.4c8.525-.033,17.052-.215,25.573-.056,8.642.16,12.775,4.6,12.783,13.33.021,21.85-.062,43.7.082,65.548.022,3.326-.905,4.239-4.228,4.227q-49.556-.179-99.112,0c-3.32.012-4.252-.89-4.23-4.221.145-21.981.058-43.965.085-65.947.01-8.358,4.268-12.785,12.761-12.939,8.522-.153,17.049.024,25.574.055.037,9.984.135,19.971.07,29.956-.018,2.768.706,4.055,3.25,2.11,8.069-6.171,15.992-6.218,24.068-.013,2.534,1.947,3.274.695,3.256-2.094-.066-9.986.033-19.971.069-29.957",
    transform: "translate(304.708 4916.724)",
    fill: "#fec26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    d: "M226.077,293.335c-.036,9.986-.135,19.971-.069,29.957.018,2.788-.721,4.041-3.256,2.094-8.075-6.205-16-6.158-24.068.013-2.544,1.945-3.268.658-3.25-2.11.066-9.985-.033-19.971-.07-29.956q15.355-.731,30.712,0",
    transform: "translate(295.18 4916.786)",
    fill: "#c48a58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M208.805,101.447c13.144,0,23.154,10.035,23.2,23.246.043,12.953-10.455,23.741-23.031,23.667-13.34-.078-23.583-10.252-23.6-23.439a23.031,23.031,0,0,1,23.432-23.473",
    transform: "translate(297.165 4954.842)",
    fill: "#676666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M61.606,272.958q0,10.564,0,21.129c0,1.9.1,4.073-2.488,4.187-2.607.114-3.22-1.806-3.217-4.052q.019-21.328-.006-42.656c0-2.077.524-4.037,2.809-4.049,2.586-.014,2.934,2.127,2.921,4.313-.043,7.043-.016,14.085-.016,21.129",
    transform: "translate(322.894 4925.817)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M61.583,222.539c0,1.456.021,2.912-.01,4.367a2.52,2.52,0,0,1-2.651,2.809,2.62,2.62,0,0,1-2.981-2.91c-.043-2.91-.1-5.827.046-8.731.088-1.779,1.067-2.99,3.075-2.851,1.811.127,2.49,1.291,2.519,2.95.026,1.455,0,2.911,0,4.367",
    transform: "translate(322.894 4932.236)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    d: "M137.286,54.494a4.332,4.332,0,0,1-2.415,2.984q-18.629,11.5-37.263,22.984c-1.77,1.091-3.6,1.428-4.833-.63-1.139-1.9.015-3.257,1.632-4.256Q113.2,63.964,132,52.362c1.315-.813,2.662-1.284,4.06-.252a2.823,2.823,0,0,1,1.224,2.385",
    transform: "translate(315.656 4964.763)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M165.479,41.9c.023,2.635-6.72,6.908-8.914,5.788a2.445,2.445,0,0,1-1.147-1.034c-1.743-4.262,2.344-4.591,4.367-6.192,1.779-1.408,3.826-2.087,5.4.473a3.483,3.483,0,0,1,.3.966",
    transform: "translate(303.201 4967.208)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    d: "M392.94,161.541c.595-.082.822.2.767.772l-.767-.772",
    transform: "translate(255.921 4942.903)",
    fill: "#fec26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M393.93,162.55c.549-.028.776.242.719.776l-.719-.776",
    transform: "translate(255.724 4942.701)",
    fill: "#fec26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M394.912,163.628a.621.621,0,0,1,.756.69l-.756-.69",
    transform: "translate(255.529 4942.487)",
    fill: "#fec26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M395.945,164.591l.739.666-.739-.666",
    transform: "translate(255.324 4942.295)",
    fill: "#fec26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-add-circle",
    "data-name": "Icon ionic-md-add-circle",
    d: "M67.555,3.375a64.18,64.18,0,1,0,64.18,64.18A64.18,64.18,0,0,0,67.555,3.375Zm33.016,70.66H74.035V100.57H61.075V74.035H34.539V61.075H61.075V34.539H74.035V61.075H100.57Z",
    transform: "translate(573.301 4997.215)",
    fill: "#ff6625"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenexIc);
export default __webpack_public_path__ + "static/media/genex-ic.47f642d3a6ea4f3bcce1c5cee2fea3f5.svg";
export { ForwardRef as ReactComponent };